import axios from 'axios'
import {setAuth} from '../../../../modules/auth/core/AuthHelpers'
import type {AuthModel} from '../../../../modules/auth/core/_models'

export const DIGITAL_VOS_JWT_SESSION_KEY = 'digital-vos-jwt'

/** Legacy key used by signature image proxy and other API helpers. */
export const ACCESS_TOKEN_KEY = 'accessToken'

export function getBearerToken(): string | null {
  try {
    const sessionJwt = sessionStorage.getItem(DIGITAL_VOS_JWT_SESSION_KEY)
    if (sessionJwt?.trim()) return sessionJwt.trim()

    const legacy = localStorage.getItem(ACCESS_TOKEN_KEY)
    if (legacy?.trim()) return legacy.trim()

    const raw = localStorage.getItem('kt-auth-react-v')
    if (raw) {
      const auth = JSON.parse(raw) as AuthModel
      if (auth?.token?.trim()) return auth.token.trim()
    }
  } catch {
    // ignore parse errors
  }
  return null
}

export function bootstrapJwtAuth(token: string): void {
  const trimmed = token.trim()
  if (!trimmed) return

  sessionStorage.setItem(DIGITAL_VOS_JWT_SESSION_KEY, trimmed)
  localStorage.setItem(ACCESS_TOKEN_KEY, trimmed)

  const auth: AuthModel = {
    isAuthenticated: true,
    message: '',
    userName: '',
    email: '',
    roles: '',
    token: trimmed,
    refreshTokenExpiration: '',
  }
  setAuth(auth)
  axios.defaults.headers.common.Authorization = `Bearer ${trimmed}`
}

export function clearJwtBootstrap(): void {
  sessionStorage.removeItem(DIGITAL_VOS_JWT_SESSION_KEY)
}
